
import { mapToCanActivate } from "@angular/router";
import {TextTemplatesListComponent} from "./text-templates-list/text-templates-list.component"
import {TextTemplateDetailComponent} from "./text-template-detail/text-template-detail.component";
import { LunaClaimValues } from "../models/user-identity.model";
import { InternalGuardService } from "../auth/guards/internal-guard.service";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
const systemPermissionGuards = [BaseGuardService, InternalGuardService, SystemPermissionGuardService];
export const TEXT_TEMPLATES_ROUTES: any = [
  { path: "", redirectTo: "list", pathMatch: "full",
    data: { permission: LunaClaimValues.ManageWorkflows } },
  { path: "list", component: TextTemplatesListComponent, canActivate: mapToCanActivate(systemPermissionGuards),
  data: { permission: LunaClaimValues.ManageWorkflows }  },
  { path: ":id", component: TextTemplateDetailComponent, canActivate: mapToCanActivate(systemPermissionGuards),
  data: { permission: LunaClaimValues.ManageWorkflows }  },
];